/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import Nvl from 'loracoms/Nvl';
import ShowIf from 'loracoms/ShowIf';
import HideIf from 'loracoms/HideIf';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import BillingAvatar from '../BillingAvatar';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  orgBasic: React.PropTypes.object.isRequired,
  accountBasic: React.PropTypes.object.isRequired,
  plan: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class BillingCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      orgBasic: props.orgBasic,
      accountBasic: props.accountBasic,
      plan: props.plan,
    };
    this.intlMsg = new IntlMsg(props.intl, 'overview.billing');
  }

  componentWillReceiveProps(nextProps) {
    const { orgBasic, accountBasic, plan } = nextProps;
    if (orgBasic !== this.props.orgBasic) {
      this.setState({ orgBasic });
    }
    if (accountBasic !== this.props.accountBasic) {
      this.setState({ accountBasic });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  localeDay(day) {
    const locale = this.props.intl.locale;
    if (locale === 'zh') {
      return `${day}日`;
    } else if (day === 1) {
      return `${day}st`;
    } else if (day === 2) {
      return `${day}nd`;
    } else if (day === 3) {
      return `${day}rd`;
    }
    return `${day}th`;
  }

  render() {
    const { pushState } = this.props;
    const { accountBasic, orgBasic, plan } = this.state;
    const {
      status: accStatus,
      data: { name } = {},
    } = accountBasic;
    const {
      status: orgStatus,
      data: { balance } = {},
    } = orgBasic;
    const {
      status: planStatus,
      data: { tier = 999, remaining, billday } = {},
    } = plan;

    return (
      <div className={styles.card}>
        <Row>
          <Col md={4} xs={4} className="collapse-right">
            <ShowIf if="profile:cube">
              <BillingAvatar />
            </ShowIf>
            <HideIf if="profile:cube">
              <Link onClick={() => pushState('/billing')}>
                <BillingAvatar />
              </Link>
            </HideIf>
          </Col>
          <Col md={8} xs={8}>
            <div className={styles.basic}>
              Hi, <Nvl val={name} status={accStatus} />!
            </div>
            <HideIf if="profile:cube">
              <div>
                <div className={styles.balance}>
                  {this.intlMsg.msg('balance')}
                  <span className={`${styles.value} ${balance < 0 ? styles.debt : ''}`}>
                    <Nvl val={balance} status={orgStatus} />
                  </span>
                  {this.intlMsg.msg('yuan')}
                </div>
                <Button
                  bsStyle="aisz-primary"
                  bsSize="xsmall"
                  onClick={() => pushState('/billing/recharge')}
                >
                  {this.intlMsg.msg('recharge')}
                </Button>
              </div>
            </HideIf>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <HideIf if="profile:cube">
              <div>
                <div className={styles.tier}>
                  <ShowIf if={tier === 1}>
                    <div> {this.intlMsg.msg('tier.free')} </div>
                  </ShowIf>
                  <ShowIf if={tier === 2}>
                    <div> {this.intlMsg.msg('tier.svcpkg')} </div>
                  </ShowIf>
                  <ShowIf if={tier <= 2}>
                    <div>
                      {this.intlMsg.msg('tier.remaining')}
                      <span className={styles.value}>
                        <Nvl val={remaining} status={planStatus} />
                      </span>
                      {this.intlMsg.msg('tier.day')}
                    </div>
                  </ShowIf>
                  <ShowIf if={tier === 3}>
                    <span> {this.intlMsg.msg('tier.comm') }</span>
                  </ShowIf>
                </div>
                <ShowIf if={tier <= 2}>
                  <div className={styles.promote}>
                    <Button
                      bsStyle="aisz-warning"
                      onClick={() => pushState('/billing/plans')}
                    >
                      <span className="halflings halflings-upload" />{' '}
                      {this.intlMsg.msg('promote.upgrade')}
                    </Button>
                  </div>
                </ShowIf>
                <ShowIf if={tier === 3}>
                  <div className={styles.billday}>
                    {this.intlMsg.msg('tier.comm.billday')}
                    <span className={styles.value}>
                      {this.localeDay(billday)}
                    </span>
                  </div>
                </ShowIf>
                <ShowIf if={balance < 0 && remaining > 0 && tier === 3}>
                  <div className={styles.arrear}>
                    {this.intlMsg.msg('tier.comm.arrear.willstop.prefix')}
                    <span className={styles.value}>{remaining}</span>
                    {this.intlMsg.msg('tier.comm.arrear.willstop.postfix')}
                  </div>
                </ShowIf>
              </div>
            </HideIf>
            <ShowIf if="profile:cube">
              <div className={styles.greeting}>
                {this.intlMsg.msg('cube.welcome')}
              </div>
            </ShowIf>
          </Col>
        </Row>
      </div>
    );
  }
}

BillingCard.propTypes = propTypes;

const mapStateToProps = state => ({
  orgBasic: state.org.basic,
  accountBasic: state.account.basic,
  plan: state.billing.plan,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BillingCard));




// WEBPACK FOOTER //
// ./src/containers/Overview/BillingCard/index.jsx